import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { LocalstorageService } from '../storage/localstorage.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ParamAlertService {

  constructor(
    private API: ApiService,
    private localStorage: LocalstorageService
  ) { }

    private dataSubject = new BehaviorSubject<string>("")

    data$ = this.dataSubject.asObservable();

  updateParamAlert(valor:any, id_empresa:any){
    const _self = this;
    if(valor){
      _self.API.getFromApi('Login', 'testeCertificado', {id_empresa:id_empresa, retString:false},(Retorno:any)=>{
        if(Retorno.mostraRetorno){
          console.log("RETORNO API =", Retorno);
        }
        _self.localStorage.setData('PARAM_ALERT', Retorno.message);
        _self.dataSubject.next(Retorno.message)
        // window.location.reload()
      },false,"")
    }else{
      _self.localStorage.setData('PARAM_ALERT', 'O parâmetro validação SEFAZ está desativado!');
      _self.dataSubject.next("O parâmetro validação SEFAZ está desativado!")
      // window.location.reload()
    }
  }

  setParam(value:string){
    const _self = this;
    _self.localStorage.setData('PARAM_ALERT', value);
    _self.dataSubject.next(value)
  }



}
